import { PromotionResponseDto } from '@tiendanube/common';
import { PromotionTypes } from '@tiendanube/common/src/domains/marketing/promotions/PromotionTypes';
import { PromotionFormValues } from '../components';

export const getDiscountText = (discount, t) => {
  if (discount.type === PromotionTypes.CROSS_SELLING) {
    return t('orderSummaryCard.tableAmounts.crossSellingPromotion', {
      rewardName: discount.scopeName,
    });
  }
  if (discount.isCustom) {
    return discount.name;
  }

  if (!discount.name) {
    return t('orderSummaryCard.tableAmounts.promotionDiscountDefault', {
      promotionType: discount.type,
    });
  }

  if (
    discount.type === 'NAtX%off' ||
    discount.type === PromotionTypes.PERCENTAGE_OFF
  ) {
    return discount.name;
  }

  return t('orderSummaryCard.tableAmounts.promotionDiscount', {
    promotionName: discount.name,
    promotionType: discount.type,
  });
};

export const isPercentageOffPromotion = (
  promotion: PromotionResponseDto | PromotionFormValues,
): boolean => promotion.promotionType === PromotionTypes.PERCENTAGE_OFF;
